import { useNavigate } from 'react-router-dom';
import Background from '../../components/Background/Background';
import Button from '../../components/Button/Button';
import Logo from '../../components/Logo/Logo';
import './_styles.home.css';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';
import { useAppSelector } from '../../hooks/useApp';
import Loader from '../../components/Loader/Loader';
import { loginPlaneVariants } from '../../animations/plane';

const Home = () => {
  const navigate = useNavigate();
  const { status, clientId, source } = useAppSelector((state) => state.auth);

  const onStartClick = () => {
    analytics.track('Get Started Button Clicked', {location: window.location.href, clientId, source});
    navigate('/welcome');
  };

  if (status === 'loading') {
    return (
      <Background image='start-page'>
        <div className='loading-gradient' />
        <motion.div
          className='flex gap-4 h-full justify-center items-end'
          variants={fadeIn()}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          <Loader />
          <p className='font-bold text-white'>Please Wait...</p>
        </motion.div>
      </Background>
    );
  }

  return (
    <Background image='start-page'>
      <div className='frontpage-gradient' />
      <div className='h-[75vh] lg:h-[80vh] flex flex-col justify-between items-center w-full'>
        <motion.img
          initial='hidden'
          animate='enter'
          exit='exit'
          src='/homeplane.png'
          className='home-plane'
          variants={loginPlaneVariants}
        />
        <motion.div
          className='frontpage-header'
          variants={fadeIn()}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          <Logo name='awayz' className='max-w-[100%]' />
          <p>by</p>
          <div className='w-[70%]'>
            <Logo name='ccc-horizontal' className='max-w-[100%]' />
          </div>
        </motion.div>
        <Button onClick={onStartClick}>Get Started</Button>
      </div>
    </Background>
  );
};

export default Home;
